/**
 * The United States ensign, ~1861: 13 stripes and a blue canton 7 stripes deep and 0.76 of the
 * hoist wide, on a 1:1.9 field. The number of stars is a parameter; they are set in rows of
 * near-equal length, longer rows first and last, as on many flags of the period.
 */
export function starsAndStripes(stars: number): string {
  const H = 20;
  const W = 38;
  const stripe = H / 13;
  const cantonH = stripe * 7;
  const cantonW = H * 0.76;
  const parts: string[] = [`<path fill="#B22234" d="M0 0h${W}v${H}H0z"/>`];
  const whites = [];
  for (let i = 1; i < 13; i += 2) whites.push(`M0 ${r(i * stripe)}h${W}v${r(stripe)}H0z`);
  parts.push(`<path fill="#F4F1E8" d="${whites.join('')}"/>`);
  parts.push(`<path fill="#2B2F6B" d="M0 0h${r(cantonW)}v${r(cantonH)}H0z"/>`);

  const rows = Math.max(1, Math.round(Math.sqrt((stars * cantonH) / cantonW)));
  const base = Math.floor(stars / rows);
  let extra = stars - base * rows;
  const counts = Array.from({ length: rows }, () => base);
  // Hand the extra stars to rows from the outside in.
  for (let k = 0; extra > 0; k++, extra--) {
    const row = k % 2 ? rows - 1 - (k >> 1) : k >> 1;
    counts[row] = (counts[row] ?? 0) + 1;
  }
  const longest = Math.max(...counts);
  const radius = Math.min(cantonW / longest, cantonH / rows) * 0.36;
  const star: string[] = [];
  counts.forEach((n, row) => {
    const cy = (cantonH / rows) * (row + 0.5);
    for (let i = 0; i < n; i++) star.push(starPath((cantonW / n) * (i + 0.5), cy, radius));
  });
  parts.push(`<path fill="#F4F1E8" d="${star.join('')}"/>`);
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${W} ${H}">${parts.join('')}</svg>`;
}

const r = (v: number) => Math.round(v * 100) / 100;

function starPath(cx: number, cy: number, R: number): string {
  const inner = R * 0.382;
  let d = '';
  for (let i = 0; i < 10; i++) {
    const a = -Math.PI / 2 + (i * Math.PI) / 5;
    const rad = i % 2 ? inner : R;
    d += `${i ? 'L' : 'M'}${r(cx + rad * Math.cos(a))} ${r(cy + rad * Math.sin(a))}`;
  }
  return `${d}Z`;
}
